<div @parent>
  <mat-expansion-panel
    #panel
    [className]="'group-panel' + (!panel.expanded ? ' collapsed' : '')"
    [expanded]="fieldsGroup?.expanded"
  >
    <mat-expansion-panel-header>
      <mat-panel-title class="group-title">
        <span class="display-name" translate>{{ fieldsGroup.translationKey }}</span>
        <svg-icon src="arrow-single" preserveAspectRatio="none" [stretch]="true"></svg-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div>
      @for (field of fieldsGroup.groupFields; track field.id) {
        @if (field.displayed) {
          <app-data-filter-field
            [attr.data-test-id]="field.id"
            [fieldId]="field.id"
            [filterInstanceId]="filterInstanceId"
            [expandable]="false"
          ></app-data-filter-field>
        }
      }
    </div>
  </mat-expansion-panel>
</div>
